import React from "react";
import { ArrowLeft } from "lucide-react";
import telegramService from "../../utils/telegram";

/** Telegram BackButton bo'lmagan eski klientlar uchun in-app ortga tugma */
const StepBack: React.FC<{ onBack: () => void }> = ({ onBack }) => {
  if (telegramService.hasBackButton) return null;
  return (
    <button
      onClick={onBack}
      aria-label="Back"
      className="self-start py-4 -ml-2 text-content-tertiary hover:text-content-secondary"
    >
      <ArrowLeft size={24} />
    </button>
  );
};

export default StepBack;
